<template>
  <div class="p-5 text-center">
    <span class="spinner-border spinner-border-sm" role="status">
      <span class="visually-hidden">
        {{ i18n('Loading...') }}
      </span>
    </span>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {};
  },
  created() {
    this.$root.setPageTitle(this.i18n('Do Login'));

    let urlParams = Object.fromEntries(new URLSearchParams(window.location.search));
    let decodedParams = JSON.parse(atob(urlParams.code));

    if (!decodedParams.redirect_uri
      || !decodedParams.cookie
    ) {
      this.$router.push('/');
      return;
    }

    this.processCode(decodedParams);
  },
  methods: {
    processCode(params) {
      window.localStorage.ad_cookie = params.cookie;
      window.location.href = params.redirect_uri.toString();
    },
  }
};
</script>